export function handleLayoutHistoryShortcut(
  event: KeyboardEvent,
  undo: () => void,
  redo: () => void,
): void {
  if (!event.ctrlKey && !event.metaKey) return;

  const key = event.key.toLowerCase();
  if (key === 'z' && !event.shiftKey) {
    event.preventDefault();
    undo();
  } else if ((key === 'z' && event.shiftKey) || (key === 'y' && event.ctrlKey && !event.shiftKey)) {
    event.preventDefault();
    redo();
  }
}

export interface LayoutHistoryShortcutLabels {
  undo: string;
  redo: string;
}

export function getLayoutHistoryShortcutLabels(
  platform = typeof navigator === 'undefined' ? '' : navigator.platform,
): LayoutHistoryShortcutLabels {
  const isMac = /^Mac/i.test(platform);
  return isMac
    ? { undo: 'Cmd+Z', redo: 'Cmd+Shift+Z' }
    : { undo: 'Ctrl+Z', redo: 'Ctrl+Y' };
}